import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  VitaAvailableCountry,
  VitaCountry,
  VitaWalletService,
} from '../../../services/vita-wallet.service';

/**
 * Agregar país al whitelist.
 *
 * Fuente: lista en vivo de Vita (`/catalog/countries/available`).
 * Muestra SOLO los países que Vita publica y NO tenemos en DB todavía.
 * Al elegir uno, llama `POST /catalog/countries` con el ISO-2 del país
 * — el backend valida contra Vita en vivo antes de insertar.
 */
@Component({
  selector: 'app-add-country-dialog',
  templateUrl: './add-country-dialog.component.html',
  styleUrls: ['./add-country-dialog.component.sass'],
})
export class AddCountryDialogComponent implements OnInit {
  loading = true;
  error: string | null = null;
  availableCountries: VitaAvailableCountry[] = [];
  search = '';
  addingCode: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<AddCountryDialogComponent>,
    private vita: VitaWalletService,
  ) {}

  ngOnInit(): void {
    this.loadAvailableCountries();
  }

  loadAvailableCountries(): void {
    this.loading = true;
    this.error = null;
    this.vita.listAvailableCountries().subscribe({
      next: (all) => {
        // Solo los que Vita publica y no tenemos en DB
        this.availableCountries = (all || []).filter((c) => !c.inDb);
        this.loading = false;
      },
      error: (err) => {
        if (err?.transient) {
          this.loading = false;
          return;
        }
        this.error =
          typeof err === 'string'
            ? err
            : 'Error obteniendo países disponibles en Vita';
        this.loading = false;
      },
    });
  }

  get filtered(): VitaAvailableCountry[] {
    const q = this.search.trim().toLowerCase();
    if (!q) return this.availableCountries;
    return this.availableCountries.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.code.toLowerCase().includes(q) ||
        c.currency.toLowerCase().includes(q),
    );
  }

  add(country: VitaAvailableCountry): void {
    if (this.addingCode) return;
    this.addingCode = country.code;
    this.vita
      .createCountry({
        code: country.code,
        name: country.name,
        currency: country.currency,
        flagIcon: country.flagIcon,
      })
      .subscribe({
        next: (created: VitaCountry) => {
          this.addingCode = null;
          this.dialogRef.close(created);
        },
        error: (err) => {
          this.addingCode = null;
          this.error =
            typeof err === 'string' ? err : `No se pudo agregar ${country.code}`;
        },
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
